<template>
  <span v-for="obj in text" :key="obj.id">
    <a-tag color="#87d068" style="margin-bottom: 1px" v-if="obj.parent_name">
      {{ obj.parent_name }}&nbsp;>&nbsp;{{ obj.name }}
    </a-tag>
    <a-tag color="#87d068" style="margin-bottom: 1px" v-if="!obj.parent_name">
      {{ obj.name }}
    </a-tag>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Cell_menu_list',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [Number, String, Boolean],
      required: false,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
});
</script>
